import MatchedMap from 'utilities/src/matchedMap';
import { ButtonBGEnum } from '../../../types/_bg';

const buttonClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'border-b-2 pr-8 bg-transparent border-current focus:shadow-v-ring active:shadow-none'],
  [ButtonBGEnum.Dark, 'border-b-2 pr-8 bg-transparent border-current focus:shadow-v-ring active:shadow-none'],
]);

const buttonDisabledClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'disabled:text-site-neutrals-200'],
  [ButtonBGEnum.Dark, 'disabled:text-site-neutrals-500'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'transform duration-200 hover:px-4'],
  [ButtonBGEnum.Dark, 'transform duration-200 hover:px-4'],
]);

const buttonSiteTertiaryClasses = [buttonClassesMap, buttonDisabledClassesMap, buttonHoverClassesMap];

export default buttonSiteTertiaryClasses;
